module.exports = __webpack_public_path__ + "img/host.3ebfdf0a.svg";